<template lang="jade">
	include ../../node_modules/tangram-ui/src/elements/tge-svg-icons/tge-svg-icons.jade

	.district-results(v-if="district")
		//- .district-results_title
			h4 {{ name }}
			span.counted()
				{{ percentCounted }} % counted.
		//- .district-results_content
		.district-results_table(cellspacing="0")
			.thead
				.th.name
					.district-results_title
						h4 {{ name }}
						span.counted() {{ percentCounted }} % counted.
				.th.party|Party
				.th.votes|Count
				.th.percent|%
			.tr(v-for="(candidate, i) in candidates", :key="i", :party="candidate['party']", :style="{ 'background-size': candidate.primaryVotes.percentage + '% 100% '}")
				.td.name
					.candidate_name
						span.firstname {{ candidate.givenNames }}
						span.lastname {{ candidate.surname }}
				.td.party {{ candidate['party'] }}
				.td.votes {{ candidate.primaryVotes.count }}
				.td.percent {{ candidate.primaryVotes.percentage }}

</template>
<script>
	export default {
		name: "tooltip",
		props: {
			district: {
				type: Object,
				default: () => ({})
			}
		},
		computed: {
			districtData() { 	return this.district || {}; },
			candidates() { 		return this.districtData && this.districtData.candidates || [];  },
			name() { 			return this.districtData['name']; },
			percentCounted() { 	return this.districtData['percentRollCounted']; }
		}
	}
</script>
<style lang="scss">
	@import "src/_commons/assets/scss/global-sass";

	.district-results {
		display: flex;
		flex-direction:column;
		@include tgs-font-base-m;

		&_content {
			// flex: 1 1 100%;
		}

		&_title {
			display: flex;
			width: 100%;
			// justify-content: space-between;
			// align-items: center;
			// justify-content: flex-end;
			flex-direction: column;
			line-height: 1.2;
			@include tgs-font-title-xs;

			h4 { text-transform: uppercase; margin:0 0 3px; color: #000; }
			span { color: #666; font-size: 12px; font-weight:normal; line-height: 1.4; }
		}
	}




	.district-results_table {
		flex-grow: 1;
		width: 100%;
		text-align: left;
		// margin-top: $m-spacing;
		// height: 100%;
		@include MQ_MediumLarge {
			line-height: 0.8rem;
		}
		@include MQ_SmallOnly() {
			line-height: 1rem;
		}

		display: flex;
		flex-direction: column;

		.thead {
			display: flex;
		}

		.tr {
			border-top: 1px solid #d0d0d0;

			flex-grow: 1;
		}

		.th,
		.td {
			font-size: 14px;
			align-items: center;
			padding: 0 6px;
			display: flex;
			flex-flow: row nowrap;
			flex-grow: 1;
			flex-basis: 0;
			word-break: break-word;
			text-overflow: ellipsis;
			min-width: 40px;
			white-space: nowrap;
			line-height: 100%;

			&.name {
				flex-grow: 4;
				padding-left:0;
			}

			&.votes {
				flex-grow:1.3;
			}
		}


		.th {
			align-items: flex-end;
			font-weight: bold;
			padding: 0 $m-spacing $m-spacing;
			color: #666;
		}

		.td.name {
			border-left: 5px solid;
		}

		.candidate_name {
			height: 100%;
			padding: 4px $m-spacing;
			display: flex;
			flex-direction: column;
			justify-content: center;

			.firstname { font-size: 0.8em; color: #333;  }
			.lastname { text-transform: uppercase; font-weight: bold; }
		}

		.tr {
			background: transparent $m-spacing 0px no-repeat;
			transition: all 0.3s 0.1s ease;
			display: flex;

			&[party="LNP"] {
				background-image: linear-gradient(to right, $color-LNP-bar, $color-LNP-bar);
				.td.name { border-color: $color-LNP; }
			}
			&[party="ALP"] {
				background-image: linear-gradient(to right, $color-ALP-bar, $color-ALP-bar);
				.td.name { border-color: $color-ALP; }
			}
			&[party="GRN"] {
				background-image: linear-gradient(to right, $color-GRN-bar, $color-GRN-bar);
				.td.name { border-color: $color-GRN; }
			}
			&[party="ZZZ"] {
				background-image: linear-gradient(to right, $color-IND-bar, $color-IND-bar);
				.td.name { border-color: $color-IND; }
			}
			&[party="KAP"] {
				background-image: linear-gradient(to right, $color-KAP-bar, $color-KAP-bar);
				.td.name { border-color: $color-KAP; }
			}
			&[party="PUP"] {
				background-image: linear-gradient(to right, $color-OTH-bar, $color-OTH-bar);
				.td.name { border-color: $color-OTH; }
			}
			&[party="ONP"] {
				background-image: linear-gradient(to right, $color-ONP-bar, $color-ONP-bar);
				.td.name { border-color: $color-ONP; }
			}
			&[party="FFP"] {
				background-image: linear-gradient(to right, $color-FFP-bar, $color-FFP-bar);
				.td.name { border-color: $color-FFP; }
			}
		}
	}


		div.tooltip {
			position: fixed; //absolute; //fixed; // absolute;
			z-index: 999;
			background-color: white;
			border: 1px solid black;
			color: currentColor;
			padding: $m-spacing-x2;
			display: none;
			max-width: 99vw;

			&.visible {
				display: block;
			}

			@include MQ_MediumLarge {
				min-width: 400px;
				&.visible {

				}
			}
			@include MQ_SmallOnly() {
				width: 90%;
				width: calc(100% - #{$m-spacing-x2});
				left: $m-spacing !important;
				top: 50% !important;
				transform: translateY(-50%);
				// top: 50vh !important;
				// max-width: 90%;
				&.visible {
					~ .tooltip-overlay {
						position: absolute;
						background: white;
						opacity: 0.2;
						width: 100%;
						height:100%;
					}
					~ .all-results_content { transition: 0.3s ease; opacity:0.3; filter: blur(2px); }
				}
			}



			&,
			* {
				pointer-events:none;
			}

			.tge-svg-icon_close {
				width: 16px;
			    height: 16px;
			    // margin-bottom: $m-spacing;

			}

			.tooltip_close {
				top: 0; //$m-spacing;
				right: 0; //$m-spacing;
				padding: $m-spacing-x2;
				position: absolute;
				cursor: pointer;

				&,
				* {
					pointer-events:all;
				}

				&:hover {
					.tge-svg-icon path { fill: #666; }
				}
			}


		}

</style>



// WEBPACK FOOTER //
// DistrictDataTable.vue?4790e1e6